import { Component, OnInit } from '@angular/core';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { firstValueFrom } from 'rxjs';
import { TransactionsService } from '../_services/transactions.service';
import { TransactionsTypesService } from '../_services/transactions-types.service';
import { ThirdPartiesService } from '../_services/third-parties.service';
import { AffectedsService } from '../../cases/_services/affecteds.service';
import { TransactionsStatesService } from '../_services/transactions-states.service';
import { Business } from '../../business/_types/business';
import { BusinessService } from '../../business/_services/business.service';
import { Transaction } from '../_types/transaction';
import { TemplatesService } from '../../templates/_services/templates.service';
import { Tax } from '../../taxes/_types/tax';
import { TaxesService } from '../../taxes/_services/taxes.service';
import { FilterFieldConfig } from 'src/app/core/filter-panel/filter-field.model';
import { TransactionsLinesService } from '../_services/transactions-lines.service';

@Component({
    selector: 'app-transactions-retentions',
    templateUrl: './transactions-retentions.component.html',
    styleUrls: ['./transactions-retentions.component.scss'],
    host: { class: 'list-page' },
    standalone: false
})
export class TransactionsRetentionsComponent implements OnInit {
  public transactions: any = [];
  public transactionType: any = {};
  public totalRecords: number = 0;
  public loading: boolean = false;
  public type!: string;
  public typeSelected: any = {};
  private lastGridEvent: any;
  public filtersDate: any = {};

  public dateFromChip: Filter = new Filter(FilterOperation.greaterOrEqual, 'date');
  public dateToChip: Filter = new Filter(FilterOperation.lessOrEqual, 'date');
  public thirdPartyOptions: { label: string; value: any }[] = [];
  public stateOptions: { label: string; value: any }[] = [];
  public businessOptions: { label: string; value: any }[] = [];
  public filters: any = {
    code: new Filter(FilterOperation.contains, 'code'),
    thirdPartyId: new Filter(FilterOperation.equals, 'thirdPartyId'),
    transactionStateId: new Filter(FilterOperation.equals, 'transactionStateId'),
    businessId: new Filter(FilterOperation.equals, 'businessId'),
    dateFrom: new Filter(FilterOperation.greaterOrEqual, 'date'),
    dateTo: new Filter(FilterOperation.lessOrEqual, 'date'),
  };
  public fieldsConfig: FilterFieldConfig[] = [
    { filter: this.filters.thirdPartyId, type: 'select', label: 'Compañía', options: this.thirdPartyOptions, filterable: true, base: true },
    { filter: this.filters.transactionStateId, type: 'select', label: 'Estado', options: this.stateOptions, base: true },
    { filter: this.filters.businessId, type: 'select', label: 'Sociedad', options: this.businessOptions, base: true },
    { filter: this.dateFromChip, filterTo: this.dateToChip, type: 'date', label: 'Fecha', base: true }
  ];
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;
  public allowRowSelection: boolean = false;
  public selectedRowsIds: any[] = [];
  public selectedDate: Date = new Date();
  public displayModal: boolean = false;
  public thirdParties: any = [];
  public thirdPartyName: string = "Tercero";
  public transactionStates: any = [];
  public business: Array<Business> = new Array<Business>;
  public isPayed: boolean = false;
  public displayRetentionModal: boolean = false;
  public workRetention: any = {};
  public transactionSelected: any = {};
  public taxes: Tax[] = [];
  public loadingTaxes: boolean = false;
  public today: Date = new Date();

  constructor(
    private transactionsService: TransactionsService,
    private router: Router,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    public topbarService: TopbarService,
    private transactionsTypesService: TransactionsTypesService,
    private thirdPartiesService: ThirdPartiesService,
    private affectedsService: AffectedsService,
    private transactionsStatesService: TransactionsStatesService,
    private businessService: BusinessService,
    private templateService: TemplatesService,
    private taxesService: TaxesService,
    private transactionsLinesService: TransactionsLinesService,
  ) {
    this.allowWrite = true;
    this.allowDelete = true;
  }

  ngOnInit(): void {
    
    this.loadTransactionType();
    this.loadThirdParties();
    this.loadTransactionStates();
    this.loadBusinesses();
  }

  async loadTransactionType() {

    this.type = "company_outgoing_invoice";
    let params: IParamsCollection = {
      include: []
    }
    //creamos filtros
    params.filter = FilterBuilder.fromObject({ code: new Filter(FilterOperation.equals, 'code', '', this.type) }).build();

    let response = await firstValueFrom(this.transactionsTypesService.all(params));
    this.transactionType = response.data[0];
    
    this.topbarService.setTitle("Retenciones de obra");    

    this.thirdPartyName = "Compañía";    

    await this.loadData(this.lastGridEvent);
    
  }

  async loadThirdParties() {
    let params: IParamsCollection = { }  
    //creamos filtros
    params.filter = FilterBuilder.fromObject({thirdPartyType: new Filter(FilterOperation.equals, 'thirdPartyType', '', this.transactionType.thirdPartyType)}).build();        
    let response = await firstValueFrom(this.thirdPartiesService.all(params));    
    this.thirdParties = response.data;  
    this.fillOptions(this.thirdPartyOptions, response.data);
  }

  async loadTransactionStates() {
    let params: IParamsCollection = { sort: ['position']}    
    params.filter = FilterBuilder.fromObject({
      transactionTypeId: new Filter(FilterOperation.equals, 'transactionTypeId', '', this.transactionType.id),
      active: new Filter(FilterOperation.equals, 'active', '', true)
    }).build();       
    let response = await firstValueFrom(this.transactionsStatesService.all(params));
    this.transactionStates = response.data;
    this.fillOptions(this.stateOptions, response.data);
  }


  async loadBusinesses() {
    let response = await firstValueFrom(this.businessService.all());             
    this.business = response.data; 
    this.fillOptions(this.businessOptions, response.data);
  }

  private fillOptions(target: { label: string; value: any }[], items: any[]) {
    target.length = 0;
    target.push(...items.map(item => ({ label: item.name, value: item.id })));
  }

  async loadData($event: any) {
    
    this.lastGridEvent = $event;
    this.filtersDate.dateFrom = this.dateFromChip.value;
    this.filtersDate.dateTo = this.dateToChip.value;
    if (!this.filtersDate.dateFrom) this.filters.dateFrom.value = null;
    if (!this.filtersDate.dateTo) this.filters.dateTo.value = null;

    if(this.transactionType.id){
      let params: IParamsCollection = {      
        include: ['transactionState', 'thirdParty', 'case.company', 'business', 'relatedTransaction']
      }
  
      if(typeof $event == "undefined"){
        params.page = { number: 1, size: 25 };      
      }else{
        params.page = { number: $event.first + 1, size: $event.rows };
        if (typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];    
      }    
           
      this.filters.transactionTypeId = new Filter(FilterOperation.equals, 'transactionTypeId', '', this.transactionType.id);
      this.filters.workRetentionInvoiced = new Filter(FilterOperation.equals, 'workRetentionInvoiced', '', false);
      this.filters.workRetention = new Filter(FilterOperation.greaterThan, 'workRetention', '', 0);
      if (this.filtersDate.dateFrom != null && this.filtersDate.dateFrom != "") {
        this.filters.dateFrom = new Filter(FilterOperation.greaterOrEqual, "date", "", this.filtersDate.dateFrom.toISOString());
      }
  
      if (this.filtersDate.dateTo != null && this.filtersDate.dateTo != "") {
        this.filters.dateTo = new Filter(FilterOperation.greaterOrEqual, "date", "", this.filtersDate.dateTo.toISOString());
      }
      //creamos filtros
      params.filter = FilterBuilder.fromObject(this.filters).build();            
  
      let response = await firstValueFrom(this.transactionsService.all(params));      
      this.transactions = response.data;      
      this.totalRecords = response.meta['total'];
      this.topbarService.setCount(this.totalRecords);
    }
 
  }

  
  /*
  clearFilters() {
    this.filters = {};
    this.search();
  }
  */

  search() {
    this.lastGridEvent.first = 0;
    this.loadData(this.lastGridEvent);
  }

  edit(transaction: any) {    
    this.router.navigate(['transactions/' + this.type + '/' + (transaction && Object.keys(transaction).length > 0 ? transaction.id : 0)]);
  }
    
  async generateWorkRetention(transaction: any) {   
    this.workRetention.transactionSelectedId = transaction.id;        
    this.workRetention.date = new Date();
    this.workRetention.transactionTypeId = transaction.transactionTypeId;
    this.workRetention.total = transaction.workRetention;
    this.displayRetentionModal = true;
  }
  

  delete(transaction: any) {
    if (this.allowDelete) {      
      this.confirmationService.confirm({
        message: "¿Está seguro que desea eliminar la transacción " + transaction.code + "?",
        header: "Eliminar transacción",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.transactionsService.delete(transaction.id).subscribe({
            next: (data: any) => {
              this.messageService.add({ closable: true, severity: 'success', detail: "Transacción eliminada correctamente" });
              this.loadData(this.lastGridEvent);
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        },
        reject: (error: any) => {
          this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
        }
      });
    }
  }
        

  async exportTransaction(transactionType: string, transactionId: string){

    this.templateService.getTemplateId(transactionType, undefined, undefined, transactionId).then((result:any) => {
      if(result != null){
        this.transactionsService.export(transactionId, result.templateId, result.metadata);
      }
    });
  }

  async saveWorkRentention() {              
      let result: any = await firstValueFrom(this.transactionsService.generateWorkRetention(this.workRetention));

      this.messageService.add({ closable: true, severity: 'success', summary: 'Retención de obra facturada correctamente.' });
      this.displayRetentionModal = false;
      this.loadData(this.lastGridEvent);        
  }


  canBeInvoiced(transaction: any): boolean {
    if (!transaction?.workRetentionDate) return false;
    const retentionDate = new Date(transaction.workRetentionDate);
    return retentionDate <= this.today;
  }
  
  

}
